/**
 * Middleware responsável por detectar se o usuário está no mobile
 */
export default function checkMobile(): boolean {
  if (window.innerWidth < 760) return true;
  else return false;
}
